// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2RzgU","unreadBadge":"styles_unreadBadge__yyn_-","modalContent":"styles_modalContent__r2pSY","modal":"styles_modal__1be4K"};